// ***********************************  Please don't change file name for dark mode (use in _app.js) ******************************************

import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
import Store from "store";
import {
    fetchRelatedVideos,
    fetchVideo,
    fetchPlaylist
} from "store/posts/actions";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Link } from "routes";
import {
  isMobile
} from "react-device-detect";
import Icon from '@material-ui/core/Icon';
import TagManager from 'react-gtm-module';
import VideoDetailPlayer from "/components/VideoDetail/VideoDetailPlayer";
import VideoDetailTabs from "/components/VideoDetail/VideoDetailTabs";
import VideoDetailShareBtn from "/components/VideoDetail/VideoDetailShareBtn";
import VideoDetailCollapse from "/components/VideoDetail/VideoDetailCollapse";
import VideoCardParts from '/components/Video/VideoCardParts';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import VideoDetailUpNext from "/components/VideoDetail/VideoDetailUpNext";
import DesktopVideoCards from "/components/Video/DesktopVideoCards";
import Hidden from '@material-ui/core/Hidden';
import {getDesktopNewsItemVideoThumbnail, extractYoutubeVideoID, isFacebookApp} from '/utils/common'
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import TimeAgo from "react-timeago";
// import ShowAllVideosButton from '/components/VideoDetail/ShowAllVideosButton';
import ReactHtmlParser from 'react-html-parser';
import VideoPlaylist from '/components/VideoDetail/VideoPlaylist';
import SeoMeta from '/components/seoMeta';
import ViewCount from '/components/viewCount';
import Button from '@material-ui/core/Button';
import Axios from "/plugins/axios";
import {c} from '/utils/log';
import ReadAll from '/components/CardsSection/readAll';
import ClapprPlayer from '../components/Clappr/ClapprPlayer';
// import PlaylistCarousel from '/components/VideoDetail/PlaylistCarousel';
import SponsoredByBrand from '/components/sponsoredByBrand';
import AuthorAndTime from '/components/authorAndTime';
import {getFooterTopOffset, infiniteHandleScroll} from '/components/NextMore/infiniteHandleScroll';

const tagManagerArgs = {
    // gtmId: 'GTM-WCJSTPT',
    dataLayer: {
      userId: '001',
      userProject: 'project',
      event: '',
      CRMAuthor: 'CRMAuthor',
      Section: 'Section',
      articlePublishedDate: 'articlePublishedDate',
      // utmCampaign: 'Undefined',
      // utmContent: 'Undefined',
      // utmMedium: 'Undefined',
      // utmSource: 'Undefined',
      // utmTerm: 'Undefined'
  }
}

const styles = theme => ({
  root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  fullDivider: {
    margin: '18px 0px',
    backgroundColor: '#fff',
    opacity: 0.4,
      '&::before': {
        content: '""',
        background: '#fff',
        width: '100%',
        position: 'absolute',
        height: 1,
        left: 0,
        right: 0,
      }

  },
  time: {
    cursor: 'pointer',
    fontSize: 12,
    display: 'inline',
  },
  title: {
    cursor: 'pointer',
    lineHeight: '23px',
    fontWeight: 'normal',
    color: '#fff',
    overflowWrap: 'break-word'
  },
  authorAndTime: {
    color: '#fff'
  },
  dot: {
    margin: '0px 7px',
    fontWeight: 'bold',
    opacity: 0.5
  },
});
class VideoDetail extends Component {
  constructor(props){
    super(props);
    this.state = {
        newsItems: [],
        loading: false,
        next: this.props.links.next,
        url: this.props.url,
        expanded: false,
        open: false,
        upNext: '',
        playlistOpen: true,
        // upNext: this.props.relatedVideos.length != 0 ? this.props.relatedVideos[0] : null,
        // upNext: this.props.relatedVideos.length != 0  ? this.props.relatedVideos[0].slug: null,
        url: this.props.url.query.id
    }
      this.onPlay = this.onPlay.bind(this);
      this.onPause = this.onPause.bind(this);
      this.onVideoLoad = this.onVideoLoad.bind(this);
      this.handleScroll = infiniteHandleScroll.bind(this, this);
      // this.handleScroll = this.handleScroll.bind(this);
  }



    static async getInitialProps({ query, asPath, store, res, err, isServer }) {
        const { id } = query;
        const list = query.list ? query.list : null;
        const currentDateTime = new Date().toISOString();
        const videoType = asPath.includes("/tv/") ? 'TV' : 'VIDEO';
        await store.execSagaTasks(isServer, dispatch => {
          dispatch(fetchVideo(id));
        });
        if(list){
          await store.execSagaTasks(isServer, dispatch => {
            dispatch(fetchPlaylist(list))
          });
        }
        if(store.getState().posts.currentVideo && store.getState().posts.playlist || !list && store.getState().posts.currentVideo) {
          await store.execSagaTasks(isServer, dispatch => {
            dispatch(fetchRelatedVideos(id, currentDateTime, videoType));
            // return {id, currentDateTime, videoType, list}
          });

        }
        else {
          res.statusCode = store.getState().posts.error.status || 404;
          console.log('errorLog')
          console.log( res.statusCode)
        }
        return {id, currentDateTime, videoType, list, asPath}
    }


    handleExpandClick = () => {
      this.setState(state => ({ expanded: !state.expanded }));
    };

    desktopToggle = () => {
      this.setState(state => ({ open: !state.open }));
    };

    playlistToggle = () => {
      this.setState(state => ({ playlistOpen: !state.playlistOpen }));
    };

    nextPage = (url) => {
      // const nextPerPage = isMobile ? 6 : 8
      const newsItems = [];
      url = `/videos/${this.props.url.query.id}/related?type=${this.props.videoType}&published_date=${this.props.currentDateTime}&perPage=8&exclude=body${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
      c.log(`nextURL: ${url}`);
      this.setState({
          loading: true
       });
       c.log("nextPage:this.setState({loading:true})");
       Axios.get(url)
           .then(res => {
               res.data.data.map((value) => newsItems.push(value))
               this.setState({
                  newsItems: [...this.state.newsItems, ...newsItems],
                  next: res.data.links.next,
                  url: this.props.url,
                  loading: false,
               })
           }).catch((error) => {
             c.log("Axios Error!");
             // Error 😨
             if (error.response) {
                 /*
                  * The request was made and the server responded with a
                  * status code that falls out of the range of 2xx
                  */
                 c.log(error.response.data);
                 c.log(error.response.status);
                 c.log(error.response.headers);
             } else if (error.request) {
                 c.log(error.request);
             } else {
                 c.log('Error', error.message);
             }
             c.log(error.config);
             this.setState({
               loading: false
             });
         });
    }

    __nextBtn () {
      const {classes, uniReadable} = this.props;
      if(this.state.next != null) {
        return (
          <div className="next_more_btn_gtm" style={{textAlign: 'center', paddingBottom: 20}}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              style={{boxShadow: 'none', fontWeight: 'bold', borderRadius: 50}}
              onClick={() => !this.state.loading ? this.nextPage(this.state.next) : null}
            >
              <span>
                {
                    uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                }
              </span>
              {this.state.loading ?
                <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                    :
                <div style={{display: 'inline-flex'}}>
                  <Icon>keyboard_arrow_down</Icon>
                </div>
                  }
            </Button>

          </div>
        )
      }
    }
    onPlay() {
        console.log('onPlay');
    }
    onPause() {
        console.log('onPause');
    }
    onVideoLoad() {
        console.log('onVideoLoad');
    }

render() {
    const { classes, video, videoType, relatedVideos, playlist, links, asPath } = this.props;
    const { newsItems } = this.state;
    const views = video.ga != null ? video.ga['ga:pageviews'] : null
    const parseDescription =  video.description ? ReactHtmlParser(fontUniOrConvertZawgyi(video.description)) : null;
    const ogDescription =  video.description && parseDescription[0] ? parseDescription[0].props.children : null;
    const playlistOrVideoUrl = this.props.url.asPath;
    const onlyVideoUrl = playlistOrVideoUrl.split('?').length > 0 ? playlistOrVideoUrl.split('?')[0] : ''
    const videoUrl = playlist && !this.state.playlistOpen && isMobile ? onlyVideoUrl : playlistOrVideoUrl ;
    const isPlayListURL = playlistOrVideoUrl.includes("?list=");
    const queryId = this.props.url.query.id;
    const playlistPos = playlist ? playlist.videos.findIndex((item, i)=> item.slug == queryId) + 1 : null;
    const viewAllRouteName = this.props.videoType === 'VIDEO' ? 'videos' : 'tv';
    const viewAllStr = this.props.videoType === 'VIDEO' ? 'Videos' : 'TVs';
    const videoCategories = video && video.categories && video.categories.length > 0 && video.categories.map(category => category.name);
    const videoTags = video && video.tags && video.tags.length > 0 && video.tags.map(tag => tag.name);
    const keywords = video.tags.length > 0 ? `${videoCategories},${videoTags}` : `${videoCategories}`;
    const envPlayer = process.env.VIDEO_SECTION_PLAYER && process.env.VIDEO_SECTION_PLAYER.toLowerCase();
    const pagePath = this.props.url.asPath;
    const showAds = video.no_ads ? false : true;
    return (
      <div>
        <Head>
          {video && <title>{fontUniOrConvertZawgyi(video.title)}</title>}
        </Head>
        <SeoMeta
            url={`${process.env.BACKEND_URL}${videoUrl}`}
            type="video.other"
            title={fontUniOrConvertZawgyi(video.title)}
            description={ogDescription}
            image={video.posters.social}
            themeColor={video.categories[0].color}
            section={videoCategories}
            keywords={keywords}
            pubDate={video.published_date.date}
            lastMod={video.updated_at.date}
          />
        <NProgress />

        {/* mobile view */}
        <Hidden only={['lg', 'xl']}>
            { envPlayer === 'jwplayer'  ?
              <div id="videoCard" className="" style={{ zIndex: 3, position: 'absolute', height: 'calc(100vw * 0.5625)', width: '100%', background: '#000' }}>
                <VideoDetailPlayer
                  playlistPos={playlistPos}
                  queryId={queryId}
                  video={video}
                  upNext={relatedVideos[0]}
                  isPlayListURL={isPlayListURL}
                  playlist={playlist}
                  pagePath={pagePath}
                />
              </div>
              :
              <div id="videoCard" className="" style={{ zIndex: 3, position: 'relative', height: '0px', width: '100%', background: '#000' }}>
                <ClapprPlayer
                  id="test-clappr-player"
                  width="100%"
                  height="calc(100vw * 0.5625)"
                  autoPlay
                  poster={video.posters.thumb}
                  source={video.video_url}
                  onPlay={this.onPlay}
                  onPause={this.onPause}
                  onVideoLoad={this.onVideoLoad}
                  video={video}
                  upNext={relatedVideos[0]}
                  isPlayListURL={isPlayListURL}
                  playlist={playlist}
                  playlistPos={playlistPos}
                  pagePath={pagePath}
                />
              </div>
            }
            {/* <iframe width="956" height="538" src="https://www.youtube.com/embed/VSfoV_xrh78" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}

          <div id="forSpace" className="spaceHeight"></div>
          {
            playlist && isPlayListURL ?
              <VideoPlaylist playlistPos={playlistPos} queryId={queryId} playlist={playlist} videoUrl={videoUrl} playlistToggle={this.playlistToggle} playlistOpen={this.state.playlistOpen} />
              : null
            }
            <div className="mobileLayout" id="content" >
              {
                showAds ? <div style={{ textAlign: 'center', paddingTop: '0', zoom: '45%' }} id="video-ad-companion"></div> : null
              }
              {
              !this.props.url.query.list || !this.state.playlistOpen || !playlist ?
                <React.Fragment>
                  <Grid
                    container
                    direction="row"
                  >
                    <Grid item xs={10} sm={10} md={10} onClick={video.description != null ? this.handleExpandClick : null}>
                      <Typography component="h1" gutterBottom className={classes.title} style={{fontSize: 16, lineHeight: '26px'}}>
                        {fontUniOrConvertZawgyi(video.title)}
                      </Typography>
                      <AuthorAndTime
                        item={video}
                        linkColor="#fff"
                        customStyle={{color: '#fff', opacity: 0.5}}
                        views={views}
                      />
                      {video.sponsor != null ? <SponsoredByBrand sponsor={video.sponsor} /> : null }
                    </Grid>

                    {
                        video.description != null || video.tags.length != 0 ?
                          <Grid item xs={2} sm={2} md={2} onClick={this.handleExpandClick}>
                            <CardActions className={classes.actions}>
                              <IconButton
                                style={{color: '#fff', marginTop: -20}}
                                className={classnames(classes.expand, {
                                        [classes.expandOpen]: this.state.expanded,
                                    })}
                                aria-expanded={this.state.expanded}
                                aria-label="Show more"
                              >
                                <ExpandMoreIcon style={{fontSize: 20}} />
                              </IconButton>
                            </CardActions>
                            {isMobile && <span style={{ color: this.state.expanded ? '#999' : '#fff', fontSize: 12, position: 'absolute', right: 14, marginTop: -10 }}>Comments</span>}
                          </Grid>
                            : null
                    }
                  </Grid>
                  <VideoDetailCollapse asPath={onlyVideoUrl} routeName='tagItems' tagChips={video.tags} expanded={this.state.expanded} item={video} videoType={videoType} />
                  <div className={classes.fullDivider} />
                  <div style={{display: 'flex'}}>
                    <Typography component="p" variant="subtitle1" style={{ color: '#fff', opacity: 0.9, fontSize: 16, padding: '18px 0px 10px' }}>
                        Up next
                    </Typography>
                    <Icon style={{color: '#fff', opacity: 0.9, fontSize: 18, marginTop: 23}}>
                        keyboard_arrow_right
                    </Icon>
                  </div>
                  <VideoDetailUpNext items={relatedVideos} newsItems={newsItems} />
                  { links.next ?  this.__nextBtn() : null}
                  {/* <ShowAllVideosButton routeName={videoType == 'TV' ? 'tv' : 'videos'} /> */}
                  <VideoDetailShareBtn title={video.title} asPath={videoUrl} customProps={{style: { position: 'fixed', bottom: 85, right: 20, zIndex: 1}}} />
                </React.Fragment>
              : null
            }
          </div>


        </Hidden>
        {/* desktop view */}
        <Hidden only={['sm', 'xs', 'md']}>
          <div className='layout' style={{ margin: '0px auto', paddingTop: 20 }}>
            <Grid
              container
              direction="row"
            >
              <Grid item xs={8} sm={8} md={8} style={{ position: 'relative' }}>
                <div style={{padding: 14}}>
                { envPlayer === 'jwplayer' ?
                    <VideoDetailPlayer
                      playlistPos={playlistPos}
                      queryId={queryId}
                      video={video}
                      upNext={relatedVideos[0]}
                      isPlayListURL={isPlayListURL}
                      playlist={playlist}
                      pagePath={pagePath}
                    />
                    :
                    <ClapprPlayer
                      id="test-clappr-player"
                      width="100%"
                      autoPlay
                      poster={video.posters.thumb}
                      source={video.video_url}
                      onPlay={this.onPlay}
                      onPause={this.onPause}
                      onVideoLoad={this.onVideoLoad}
                      video={video}
                      upNext={relatedVideos[0]}
                      isPlayListURL={isPlayListURL}
                      playlist={playlist}
                      playlistPos={playlistPos}
                    />
                    }
                  {/* { playlist && isPlayListURL ? <PlaylistCarousel playlist={playlist} queryId={queryId} routeName={videoType == 'TV' ? 'tvDetail' : 'videoDetail'} /> : null } */}
                  {
                    showAds ? <div style={{ textAlign: 'center', paddingTop: '4px' }} id="video-ad-companion"></div> : null
                  }
                  <div style={{ position: 'relative' }}>
                    <VideoCardParts item={video} isVideoDetail customProps={{style: {fontSize: 16, lineHeight: '26px', paddingTop: 20, width: '92%', color: '#fff'}}} viewCountStyle={{style: {float: 'initial', marginLeft: 20, opacity: 0.5}}} typoComponent="h1" />
                    {video.sponsor != null ? <SponsoredByBrand sponsor={video.sponsor} /> : null }
                    <VideoDetailShareBtn asPath={videoUrl} title={video.title} customProps={{style: { position: 'absolute', top: 10, right: 0, width: 40, height: 40 } }} />
                    <VideoDetailCollapse asPath={onlyVideoUrl} routeName='tagItems' videoType={videoType} tagChips={video.tags} expanded={this.state.expanded} item={video} toggleBox={this.desktopToggle} open={this.state.open} />
                  </div>
                </div>
              </Grid>
              <Grid item xs={4} sm={4} md={4} style={{padding: 14}}>

                {
                        playlist && isPlayListURL ?
                          <VideoPlaylist playlistPos={playlistPos} queryId={queryId} videoUrl={videoUrl} playlist={playlist} playlistToggle={this.playlistToggle} playlistOpen={this.state.playlistOpen} />
                          :
                          <div style={{display: 'flex'}}>
                            <Typography component="p" variant="subtitle1" style={{ color: '#fff', opacity: 0.9, fontSize: 16, padding: '0px 0px 10px' }}>
                                Up next
                            </Typography>
                            <Icon style={{color: '#fff', opacity: 0.9, fontSize: 18, marginTop: 5}}>
                                keyboard_arrow_right
                            </Icon>
                          </div>
                      }

                <VideoDetailUpNext items={relatedVideos} newsItems={newsItems} />
                { links.next ?  this.__nextBtn() : null}

                {/* <ShowAllVideosButton routeName={videoType == 'TV' ? 'tv' : 'videos'} /> */}
              </Grid>
            </Grid>

          </div>
        </Hidden>
        {
          this.state.next == null &&
          <ReadAll
            items={relatedVideos}
            routeName={viewAllRouteName}
            paramsName={{}}
            readAll={`View All Latest ${viewAllStr}`}
            color='#fff' />
        }
      </div>
    );
    }

    componentDidMount () {

        this.setState({
          ssrDone: true,
        });

        setTimeout(() => {
          this.previousFooterTopOffset = getFooterTopOffset();
          c.log("videoDetail.js:componentDidMount:previousFooterTopOffset:Timeout:500");
          c.log(this.previousFooterTopOffset, "vs", this.newFooterTopOffset);
          window.addEventListener('scroll', this.handleScroll);
      },500);
    }
    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }

//   handleScroll(event) {
//     // console.log("handleScroll > event:");
//     // console.log(event);
//     // console.log("handleScroll > that:");
//     // console.log(that);
//     if(window.pageYOffset > 200 && !this.pageFiveLoaded) {
//       if(this.state.next != null && !this.state.loading) {
//         this.nextPage(this.state.next);
//       }
//       let nextApi = this.state.next;
//       let endInfiniteScroll = nextApi != null && nextApi.includes("page=5");
//       if(endInfiniteScroll){
//         this.pageFiveLoaded = true;
//       }
//     }
// }

  componentDidUpdate(previousProps, previousState){
    const { video, url } = this.props;

    let { utm_source, utm_medium, utm_campaign, utm_term, utm_content} = url.query
    let utmUrl = utm_campaign || utm_term ||  utm_medium || utm_source || utm_content;

    tagManagerArgs.dataLayer.CRMAuthor = video.author ? video.author.name : null;
    tagManagerArgs.dataLayer.Section = 'videos';
    tagManagerArgs.dataLayer.articlePublishedDate = video.published_date.date;

    if(utmUrl) {
      tagManagerArgs.dataLayer.utmCampaign = utm_campaign ? utm_campaign : 'Undefined'
      tagManagerArgs.dataLayer.utmContent = utm_content ? utm_content : 'Undefined'
      if(utm_medium)
        tagManagerArgs.dataLayer.utmMedium = utm_medium;
      if(utm_source)
        tagManagerArgs.dataLayer.utmSource = utm_source;
      tagManagerArgs.dataLayer.utmTerm = utm_term ? utm_term : 'Undefined'
    }
    else {
      if(video.campaign || isFacebookApp() ){
        tagManagerArgs.dataLayer.utmCampaign = video.campaign ? video.campaign.utm_campaign : "duwun-video-post";
        tagManagerArgs.dataLayer.utmContent = video.campaign ? video.campaign.utm_content : 'Undefined';
        tagManagerArgs.dataLayer.utmMedium = video.campaign ? video.campaign.utm_medium : 'social';
        tagManagerArgs.dataLayer.utmSource = video.campaign ? video.campaign.utm_source : 'facebook';
        tagManagerArgs.dataLayer.utmTerm = video.campaign ? video.campaign.utm_term : 'Undefined';
      }
    }

    TagManager.dataLayer(tagManagerArgs);
    const player_ele = document.getElementById('overlay');
    previousProps.url.query.id != this.props.url.query.id ?
      <div>
        {/* { player_ele.style.zIndex = 0 } */}
        { this.setState({
        expanded: false,
        open: false,})
        }
      </div>
    : null;
    // isMobile &&
    // window.pageYOffset != 0 &&
    // previousProps.url.query.id != this.props.url.query.id &&
    // document.getElementById("videoCard") ?
    // document.getElementById("videoCard").style.marginTop = "56px" : null

    let nextPage = this.state.next != null && this.state.next.split('?').length > 0 ? this.state.next.split('?')[1] : '';
    this.nextPageNumber = nextPage.split('page=').length > 0 ? parseInt(nextPage.split('page=')[1]) : 2;

    if(previousProps.url.query!= this.props.url.query) {
      this.initialPageLoaded = false;
      this.nextPageNumber = 2;
    }

    {/* ***** showMore and infiniteScroll Events ***** */}
    if(this.state.ssrDone && !this.state.loading) {
      const currentPageNumber = this.nextPageNumber ? this.nextPageNumber-1 : 0;
      const pageUrl = document.location.origin + document.location.pathname;
      const showMorePagePath = currentPageNumber <= 1 ? pageUrl : pageUrl + "#page-" + currentPageNumber;
      if(currentPageNumber > 1) {
        window.parent.location.hash = "page-" + currentPageNumber;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'showMoreEvent',
          showMoreEventPage: showMorePagePath,
          showMoreEventTitle: this.props.video && this.props.video.title ? this.props.video.title : 'No Title'
        });        
      }
    }

    setTimeout(() => {
      this.newFooterTopOffset = getFooterTopOffset();
      c.log("videoDetail.js:componentDidUpdate:newFooterTopOffset:Timeout:500");
      c.log(this.previousFooterTopOffset, "vs", this.newFooterTopOffset);
    },500);
  }

  static getDerivedStateFromProps(nextProps, prevState){
    if(nextProps.relatedVideos.length != 0 ) {
        if(prevState.url !== nextProps.url){
            return ({
                upNext: nextProps.relatedVideos[0],
                next: nextProps.links.next,
                newsItems:[],
            })
        }
        return null;
    }
    return {};
  }

}

VideoDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  relatedVideos: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = state => ({
  video: state.posts.currentVideo.data ? state.posts.currentVideo.data : null,
  relatedVideos: state.posts.relatedVideos.data,
  playlist: state.posts.playlist ? state.posts.playlist.data : null,
  links: state.posts.relatedVideos.links,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchRelatedVideos,
      fetchVideo,
      fetchPlaylist
    },
    dispatch
  );

  export default withRedux(Store, mapStateToProps, mapDispatchToProps)(
    withReduxSaga(withStyles(styles)(VideoDetail))
  );

